var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _QuotaHandler_instances, _QuotaHandler_config, _QuotaHandler_quotaRefreshTime, _QuotaHandler_quotaPeriodMessageTimestamps, _QuotaHandler_quotaTimeout, _QuotaHandler_pubSub, _QuotaHandler_closed, _QuotaHandler_setQuotaRefreshTimeAndPublishUpdates, _QuotaHandler_publishQuotaRefreshUpdates, _QuotaHandler_clearQuotaTimeout, _QuotaHandler_onQuotaLimitError;
import { DEFAULT_REFRESH_TIME_MS, isQuotaLimitReachedError, } from "./error";
// PubNub will throttle us to 10 messages every 30 seconds. Using this default
// just enforces the same rule on the client.
export const defaultQuotaLimits = {
    messageLimit: 10,
    periodMs: 30000,
    refreshTimeMs: DEFAULT_REFRESH_TIME_MS,
};
/**
 * QuotaHandler enforces PubNub quota limits. It serves a few functions:
 *  - Listens for QuotaLimitReachedError and sets the refresh time locally.
 *  - Tracks the frequency at which messages are sent by the client, and
 *    enforces quota limits locally, without having to hit the server for
 *    an error.
 *  - When the limit is reached and refresh time is set, publishes an event
 *    once per second counting down until the refresh time has passed.
 *
 * Note that, in some cases (for example, user is the channel owner),
 * you won't want to enforce quota limits.
 *
 * Further, use of this utility doesn't guarantee you won't hit a quota
 * limit enforced on the server (for example, if you were sending messages
 * from multiple devices). The intent here is to provide an improved UX
 * over handling server errors.
 */
export class QuotaHandler {
    constructor(pubSub, config = defaultQuotaLimits) {
        _QuotaHandler_instances.add(this);
        _QuotaHandler_config.set(this, void 0);
        _QuotaHandler_quotaRefreshTime.set(this, 0
        // Timestamps are tracked by a unique key, so that they can be updated
        // in the event that the client has to retry sending a message.
        );
        // Timestamps are tracked by a unique key, so that they can be updated
        // in the event that the client has to retry sending a message.
        _QuotaHandler_quotaPeriodMessageTimestamps.set(this, new Map());
        _QuotaHandler_quotaTimeout.set(this, void 0);
        _QuotaHandler_pubSub.set(this, void 0);
        _QuotaHandler_closed.set(this, false);
        _QuotaHandler_onQuotaLimitError.set(this, (error) => {
            if (isQuotaLimitReachedError(error) && error.refreshTimeMs >= 0) {
                __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_setQuotaRefreshTimeAndPublishUpdates).call(this, Date.now() + error.refreshTimeMs);
            }
        });
        __classPrivateFieldSet(this, _QuotaHandler_config, config, "f");
        __classPrivateFieldSet(this, _QuotaHandler_pubSub, pubSub, "f");
        pubSub.subscribe("error", __classPrivateFieldGet(this, _QuotaHandler_onQuotaLimitError, "f"));
    }
    get quotaRefreshMsRemaining() {
        return Math.max(__classPrivateFieldGet(this, _QuotaHandler_quotaRefreshTime, "f") - Date.now(), 0);
    }
    get quotaRefreshSecondsRemaining() {
        return Math.ceil(this.quotaRefreshMsRemaining / 1000);
    }
    mark(key) {
        if (__classPrivateFieldGet(this, _QuotaHandler_closed, "f")) {
            return;
        }
        const timestamp = Date.now();
        __classPrivateFieldGet(this, _QuotaHandler_quotaPeriodMessageTimestamps, "f").set(key, timestamp);
        const timestampEntriesWithinPeriod = [
            ...__classPrivateFieldGet(this, _QuotaHandler_quotaPeriodMessageTimestamps, "f").entries(),
        ].filter(([, entryTimestamp]) => timestamp - entryTimestamp <= __classPrivateFieldGet(this, _QuotaHandler_config, "f").periodMs);
        __classPrivateFieldSet(this, _QuotaHandler_quotaPeriodMessageTimestamps, new Map(timestampEntriesWithinPeriod), "f");
        if (__classPrivateFieldGet(this, _QuotaHandler_quotaPeriodMessageTimestamps, "f").size >= __classPrivateFieldGet(this, _QuotaHandler_config, "f").messageLimit) {
            __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_setQuotaRefreshTimeAndPublishUpdates).call(this, timestamp + __classPrivateFieldGet(this, _QuotaHandler_config, "f").refreshTimeMs);
        }
    }
    close() {
        __classPrivateFieldSet(this, _QuotaHandler_closed, true, "f");
        __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_clearQuotaTimeout).call(this);
        __classPrivateFieldGet(this, _QuotaHandler_pubSub, "f").unsubscribe("error", __classPrivateFieldGet(this, _QuotaHandler_onQuotaLimitError, "f"));
    }
}
_QuotaHandler_config = new WeakMap(), _QuotaHandler_quotaRefreshTime = new WeakMap(), _QuotaHandler_quotaPeriodMessageTimestamps = new WeakMap(), _QuotaHandler_quotaTimeout = new WeakMap(), _QuotaHandler_pubSub = new WeakMap(), _QuotaHandler_closed = new WeakMap(), _QuotaHandler_onQuotaLimitError = new WeakMap(), _QuotaHandler_instances = new WeakSet(), _QuotaHandler_setQuotaRefreshTimeAndPublishUpdates = function _QuotaHandler_setQuotaRefreshTimeAndPublishUpdates(refreshTimestamp) {
    __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_clearQuotaTimeout).call(this);
    __classPrivateFieldSet(this, _QuotaHandler_quotaRefreshTime, refreshTimestamp, "f");
    __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_publishQuotaRefreshUpdates).call(this);
}, _QuotaHandler_publishQuotaRefreshUpdates = function _QuotaHandler_publishQuotaRefreshUpdates() {
    const secondsRemaining = this.quotaRefreshSecondsRemaining;
    __classPrivateFieldGet(this, _QuotaHandler_pubSub, "f").publish("quotaRefreshSecondsRemaining", secondsRemaining);
    if (!secondsRemaining) {
        return;
    }
    __classPrivateFieldSet(this, _QuotaHandler_quotaTimeout, setTimeout(() => {
        __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_clearQuotaTimeout).call(this);
        if (__classPrivateFieldGet(this, _QuotaHandler_closed, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _QuotaHandler_instances, "m", _QuotaHandler_publishQuotaRefreshUpdates).call(this);
    }, 1000), "f");
}, _QuotaHandler_clearQuotaTimeout = function _QuotaHandler_clearQuotaTimeout() {
    clearTimeout(__classPrivateFieldGet(this, _QuotaHandler_quotaTimeout, "f"));
    __classPrivateFieldSet(this, _QuotaHandler_quotaTimeout, undefined, "f");
};
